import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { classes, classState } from '../types/class';

const initialState: classState = {
  classes: [],
  loading: false,
  error: null,
};

const classeslice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    fetchclassesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchclassesSuccess: (state, action: PayloadAction<classes[]>) => {
      state.loading = false;
      state.classes = action.payload;
    },
    fetchclassesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addclassestart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addclassesuccess: (state, action: PayloadAction<classes>) => {
      state.loading = false;
      state.classes.push(action.payload);
    },
    addclassFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateclassestart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateclassesuccess: (state, action: PayloadAction<classes>) => {
      state.loading = false;
      state.classes = state.classes.map((classe) =>
        classe.id === action.payload.id ? action.payload : classe
      );
    },
    updateclassFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteclassestart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteclassesuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.classes = state.classes.filter((classe) => classe.id !== action.payload);
    },
    deleteclassFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchclassesStart,
  fetchclassesSuccess,
  fetchclassesFailure,
  addclassestart,
  addclassesuccess,
  addclassFailure,
  updateclassestart,
  updateclassesuccess,
  updateclassFailure,
  deleteclassestart,
  deleteclassesuccess,
  deleteclassFailure,
} = classeslice.actions;

export default classeslice.reducer;